import React from 'react';

import {
	Alert,
	Button,
	Card,
	CardBody,
	CardHeader,
	Col,
	ModalBody,
	Modal,
	Row,
	Input
} from 'reactstrap';
import {productService} from '../../services/product.service';
import ProductsList from 'components/Products/ProductsList';
import ProductsNav from 'components/Products/ProductsNav';
import { helpers } from 'chart.js';
import { formatDate } from 'helpers';
import moment from 'moment';
import CogsList from 'components/Products/CogsList';

class Cogs extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: true,
			allProducts: [],
			categories: [],
			productList: [],
			salesArea: [],
			salesAreaCurrent: 0,
            displayFilter: "Weekly",
            startDate: new Date(),
            endDate: new Date(),
			modalOpen: false,
			modalType: null,
			saveFileName: '',
			saveDisabled: false,
			cogsSaves: [],
			downloadDisabled: false,
		};
	}

	componentDidMount() {
		console.log('DID MOUNT CALLED')
		productService.getProductsRequired().then(response => {
			this.setState({
				categories: this.uniqueCategories(response.Data.products),
				salesArea: response.Data.salesArea,}, () => {
                    this.setState({loading: false})
                });
			if (response.Data.salesArea[0]) {
				this.setState({salesAreaCurrent: response.Data.salesArea[0].ID});
			}
		});
		productService.getCogsSaves().then((response) => {
			if (response.Success) {
				this.setState({cogsSaves: response.Data})
			} else {
				console.error(response.Message)
			}
		})
	}

	updateProductList = (salesArea, filters) => {
		let productList = {};
		this.state.allProducts.forEach(product => {
			if (salesArea && product.SalesArea !== salesArea) {
				return;
			}

			// Store original quantity so it doesn't get overwritten by grouping,
			// and otherwise reset quantity to original for the new calculation.
			if (product.originalQuantity) {
				product.Quantity = product.originalQuantity;
			}
			else {
				product.originalQuantity = product.Quantity;
			}
			productList = this.updateQuantity(productList, product, 1);
		});
		this.setState({
			loading: false,
			salesAreaCurrent: salesArea,
			productList: Object.values(productList)});
	}

	updateAllProducts = () => {
		this.setState({
			loading: true,
			productList: []});
        productService.getProductsCogs(formatDate(this.state.startDate), formatDate(this.state.endDate)).then(response => {
            this.setState({
                allProducts: response.Data.products,
                categories: this.uniqueCategories(response.Data.products)});
            this.updateProductList(this.state.salesAreaCurrent);
        });
	}

	uniqueCategories = (products) => {
		let categories = {};
		products.map(p => {
			if (!categories[p.Category]) {
				categories[p.Category] = true;
			}
		});
		return Object.keys(categories).sort();
	}

	updateQuantity = (productList, product) => {
		let productDate = new Date(product.Date);
        let startWeek = moment(productDate).startOf("Week");
        let endWeek = moment(productDate).endOf("week");
        // console.log({
        //     StartDate: startWeek.format("YYYY-MM-DD"),
        //     Date: productDate.toString(),
        //     EndDate: endWeek.format("YYYY-MM-DD"),
        //     Month: moment(productDate).format("MMMM")
        // })

        let weekKey = `${startWeek.format("YYYY-MM-DD")} - ${endWeek.format("YYYY-MM-DD")}`;
        let monthKey = moment(productDate).format("MMMM");

        if (!productList[product.ID]) {
            productList[product.ID] = product;
			productList[product.ID].weeks = {};
            productList[product.ID].months = {};
        }
        if (!productList[product.ID].weeks[weekKey]) {
            productList[product.ID].weeks[weekKey] = {
                Quantity: 0,
                Ordering: moment(productDate).week()
            };

        }
        if (!productList[product.ID].months[monthKey]) {
            productList[product.ID].months[monthKey] = {
                Quantity: 0,
                Ordering: moment(productDate).format("M")
            };

        }
		productList[product.ID].weeks = Object.keys(productList[product.ID].weeks)
										.sort((a, b) => {
											return productList[product.ID].weeks[a].Ordering > productList[product.ID].weeks[b].Ordering ? 1 : -1;
										})
										.reduce((accumulator, key) => {
											accumulator[key] = productList[product.ID].weeks[key];
											return accumulator
										}, {})
		productList[product.ID].months = Object.keys(productList[product.ID].months)
										.sort((a, b) => {
											return productList[product.ID].months[a].Ordering > productList[product.ID].months[b].Ordering ? 1 : -1;
										})
										.reduce((accumulator, key) => {
											accumulator[key] = productList[product.ID].months[key];
											return accumulator
										}, {})
        // productList[product.ID].weeks = productList[product.ID].weeks.sort((a, b) => {
        //         return a.Ordering > b.Ordering ? -1 : 1;
        //     })
        // productList[product.ID].months = productList[product.ID].months.sort((a, b) => {
        //         return parseInt(a.Ordering) > parseInt(b.Ordering) ? -1 : 1
        //     })

        productList[product.ID].weeks[weekKey].Quantity += product.Quantity;
        productList[product.ID].months[monthKey].Quantity += product.Quantity;
		return productList;
	}

	updateFilters = (filter) => {
        console.log(filter)
        this.setState({displayFilter: filter});
	}

    updateDate = (key, value) => {
        var ob = {};
        ob[key] = value;
        this.setState(ob, () => {
            this.updateAllProducts();
        });
    }

	saveData = () => {
		if (this.state.saveFileName === "") {
			alert("Enter a name to reference this save data to the database")
			return
		}
		this.setState({saveDisabled: true});
		//send the product list to the database along with the name of the file
		//and then write it to the database
		console.log(JSON.stringify(this.state.productList))
		productService.saveCogsData(this.state.saveFileName, JSON.stringify(this.state.productList)).then(() => {
			this.setState({saveDisabled: false, modalOpen: false});
		})
	}

	loadData = (id) => {
		if (this.state.loading) {
			return
		}
		this.setState({loading: true});
		productService.loadCogSave(id).then((response) => {
			console.log(response.Data)
			let data = [];
			if (response.Success) {
				data = JSON.parse(response.Data.Data.replace(/\\"/g, '"'))
			}
			this.setState({loading: false,modalOpen: false, productList: data})
		}).catch(err => {
			console.error(err)
		})
	}

	downloadData = async () => {
		this.setState({downloadDisabled: true})
		var resp = await productService.downloadCogs(JSON.stringify(this.state.productList), this.state.displayFilter).then((resp) => {
			this.setState({downloadDisabled: false})
			return resp;
		}).catch(err => console.error(err))
		console.log(resp)
		const url = window.URL.createObjectURL(resp);
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", "cogs_export.csv");
			document.body.appendChild(link);
			link.click();
	}

	render() {
		const {loading,
					 categories,
					 productList,
					 salesArea,
			  } = this.state;
		return (
			<div className="content">
				<Modal size={'lg'} isOpen={this.state.modalOpen}
				toggle={() => this.setState({modalOpen: !this.state.modalOpen})}
				modalTransition={{timeout: 100}}>
					<ModalBody>
						{
							this.state.modalType == "save" &&
							<>
								<Row>
									<Col>
										<h4>Store the data for later.</h4>
									</Col>
								</Row>
								<Row>
									<Col>
										Name:
									</Col>
									<Col>
										<Input style={{color: "#000"}} type={'text'} onChange={(e) => this.setState({saveFileName: e.target.value})} />
									</Col>
								</Row>
								<Row>
									<Col>
										<Button onClick={this.saveData} disabled={this.state.saveDisabled}>Save</Button>
									</Col>
								</Row>
							</>
						}
						{
							this.state.modalType == "import" && <>
								<Row>
									<Col>
										<h4>Import previous results</h4>
									</Col>
									<Col>
										Refresh
									</Col>
								</Row>
								<Row>
									<Col>
										Name
									</Col>
									<Col>
									Created Date
									</Col>
									<Col>Created By</Col>
								</Row>
								{
									this.state.cogsSaves.map(c => {
										return (
											<a href="#" key={`cogs-save-${c.ID}`} onClick={() => this.loadData(c.ID)}>
												<Row>
													<Col>
														{c.Name}
													</Col>
													<Col>
														{moment(c.Date).format("YYYY-MM-DD HH:mm")}
													</Col>
													<Col>
														{c.CreatedBy}
													</Col>
												</Row>
											</a>
										)
									})
								}
							</>
						}
					</ModalBody>
				</Modal>
				<Alert color="primary" isOpen={loading}>
					Loading inventory data...</Alert>
				<Row>
					<Col>
						<Card>
							<CardHeader>
								<h4>Import / Export / Save</h4>
							</CardHeader>
							<CardBody>
								<Button onClick={() => this.setState({modalOpen: true, modalType: 'save'})}>Store Data For Later</Button>
								<Button onClick={() => this.setState({modalOpen: true, modalType: 'import'})}>Import to view</Button>

								<Button onClick={this.downloadData} disabled={this.state.downloadDisabled}>Export to CSV</Button>
							</CardBody>
						</Card>
					</Col>
				</Row>
				<Row>
					<Col>
						<Card>
							<CardHeader>
								<h4>Inventory Options</h4>
							</CardHeader>
							<CardBody>
								<ProductsNav salesArea={salesArea}
									updateProductList={this.updateProductList}
									updateAllProducts={this.updateAllProducts}
									updateGrowthPercentage={this.updateGrowthPercentage}
									updateFilters={this.updateFilters}
									removeFilter={this.removeFilter}
                                    cogsSelect={true}
                                    cogsDuration={["weekly", "monthly"]}
                                    cogsDurationChange={this.updateFilters}
                                    startDate={this.state.startDate}
                                    endDate={this.state.endDate}
                                    updateDate={this.updateDate}
                                    />
							</CardBody>
						</Card>
					</Col>
				</Row>
				<Row>
					<Col>
						{ categories.map(c => {
							return (
								<Card className={'card-table'} key={c}>
									<CardHeader>
										<h4>{c === '' ? 'Uncategorised' : c}</h4>
									</CardHeader>
									<CardBody>
                                        <CogsList
                                        products={productList}
                                        category={c}
                                        display={this.state.displayFilter}
                                    />
									</CardBody>
								</Card>
							)
						})}
					</Col>
				</Row>
			</div>
		);
	}
}

export default Cogs;
